export default __webpack_public_path__ + "static/media/Building_Interactive_JavaScript_Websites_-_adamr.space___Codecademy.2d9d3ded.pdf";